export const tw = [
  { _id: 'ae-giselle', name: 'ae-GISELLE', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'scorpio' },
  { _id: 'ae-karina', name: 'ae-KARINA', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'aries' },
  { _id: 'ae-ningning', name: 'ae-NINGNING', rarity: 5, role: 'manauser', attribute: 'fire', zodiac: 'crab' },
  { _id: 'ae-winter', name: 'ae-WINTER', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'capricorn' },

  { _id: 'alencia', name: '\u827e\u84ee\u897f\u96c5', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  {
    _id: 'ambitious-tywin',
    name: '\u91ce\u5fc3\u4efd\u5b50\u6cf0\u6eab',
    rarity: 5,
    role: 'knight',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'apocalypse-ravi',
    name: '\u672b\u65e5\u863f\u83f2',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'aramintha', name: '\u96c5\u62c9\u654f\u5854', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'arbiter-vildred',
    name: '\u57f7\u884c\u5b98\u7dad\u5fb7\u745e',
    rarity: 5,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'archdemons-shadow',
    name: '\u9b54\u795e\u7684\u6697\u5f71',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  {
    _id: 'aria',
    name: '\u827e\u8389\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'ice',
    zodiac: 'taurus ',
  },
  {
    _id: 'arunka',
    name: '\u4e9e\u9732\u5609',
    rarity: 5,
    role: 'warrior',
    attribute: 'wind',
    zodiac: 'scorpio',
  },
  {
    _id: 'astromancer-elena',
    name: '\u661f\u8fb0\u7684\u795e\u8aed\u827e\u857e\u5a1c',
    rarity: 5,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'taurus ',
  },
  { _id: 'baal-sezan', name: '\u5df4\u723e&\u585e\u5c1a', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'baiken', name: '\u6885\u55a7', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'basar', name: '\u5df4\u85a9\u723e', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'waterbearer' },
  { _id: 'beehoo', name: '\u96e8\u8129', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'capricorn' },
  { _id: 'belian', name: '\u4f2f\u91cc\u5b89', rarity: 5, role: 'knight', attribute: 'light', zodiac: 'aries' },
  { _id: 'bellona', name: '\u7dad\u723e\u863f\u5a1c', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'blood-moon-haste',
    name: '\u8d64\u6708\u7684\u8cb4\u65cf\u6d77\u65af\u7279',
    rarity: 5,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'bomb-model-kanna',
    name: '\u66b4\u64ca\u578b\u5361\u8fb2',
    rarity: 5,
    role: 'ranger',
    attribute: 'fire',
    zodiac: 'twins',
  },
  {
    _id: 'briar-witch-iseria',
    name: '\u7070\u5149\u68ee\u6797\u7684\u4f0a\u8cfd\u9e97\u4e9e',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'cecilia', name: '\u8cfd\u897f\u8389\u4e9e', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'celine', name: '\u745f\u7433', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'cerise', name: '\u8cfd\u745e\u7d72', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'cermia', name: '\u6f54\u82e5\u7c73\u4e9e', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'lion' },
  { _id: 'charles', name: '\u67e5\u723e\u65af', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'charlotte', name: '\u590f\u7da0\u8482', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'lion' },
  { _id: 'chloe', name: '\u514b\u863f\u611b', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'archer' },
  { _id: 'choux', name: '\u5c0f\u6ce1\u8299', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'goat' },
  {
    _id: 'closer-charles',
    name: '\u672b\u65e5\u6307\u63ee\u5b98\u67e5\u723e\u65af',
    rarity: 5,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'scorpio',
  },
  {
    _id: 'command-model-laika',
    name: '\u6307\u63ee\u578b\u840a\u4f0a\u5361',
    rarity: 5,
    role: 'ranger',
    attribute: 'wind',
    zodiac: 'gemini',
  },
  {
    _id: 'commander-pavel',
    name: '\u53f8\u4ee4\u5b98\u5e15\u8c9d\u723e',
    rarity: 5,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'lion',
  },
  {
    _id: 'conqueror-lilias',
    name: '\u652f\u914d\u8005\u8389\u8389\u4e9e\u65af',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'aquarius',
  },
  {
    _id: 'dark-corvus',
    name: '\u9ed1\u6697\u7684\u79d1\u723e\u5e03\u601d',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'goat',
  },
  {
    _id: 'death-dealer-ray',
    name: '\u6b7b\u4ea1\u63a2\u7a76\u8005\u96f7\u4f0a',
    rarity: 5,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'goat',
  },
  {
    _id: 'desert-jewel-basar',
    name: '\u6c99\u6f20\u5bf6\u77f3\u5df4\u85a9\u723e',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'designer-lilibet',
    name: '\u8a2d\u8a08\u5e2b\u8389\u8389\u8c9d',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'destina', name: '\u6234\u7d72\u8482\u5a1c', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'crab' },
  { _id: 'diene', name: '\u8fea\u57c3\u59ae', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'dizzy', name: '\u8482\u59ec', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'eda', name: '\u827e\u59b2', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  {
    _id: 'edward-elric',
    name: '\u611b\u5fb7\u83ef\u2027\u611b\u529b\u514b',
    rarity: 5,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'aries',
  },
  { _id: 'elena', name: '\u827e\u857e\u5a1c', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'twins' },
  { _id: 'elphelt', name: '\u611b\u723e\u83f2\u7279', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'goat' },
  { _id: 'emilia', name: '\u611b\u871c\u8389\u96c5', rarity: 5, role: 'manauser', attribute: 'ice', zodiac: 'gemini' },
  {
    _id: 'ervalen',
    name: '\u827e\u723e\u5df4\u502b',
    rarity: 5,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'scorpion',
  },
  {
    _id: 'fairytale-tenebria',
    name: '\u7ae5\u8a71\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'ice',
    zodiac: 'bull',
  },
  {
    _id: 'faithless-lidica',
    name: '\u7121\u795e\u8ad6\u8005\u9e97\u8fea\u5361',
    rarity: 5,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'fallen-cecilia',
    name: '\u58ae\u843d\u7684\u8cfd\u897f\u8389\u4e9e',
    rarity: 5,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'flan', name: '\u8299\u862d', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'goat' },
  { _id: 'haste', name: '\u6d77\u65af\u7279', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'holiday-yufine',
    name: '\u5ea6\u5047\u98a8\u512a\u82ac\u59ae',
    rarity: 5,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'scales',
  },
  {
    _id: 'hwayoung',
    name: '\u548c\u82f1',
    rarity: 5,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'libra',
  },
  {
    _id: 'inferno-khawazu',
    name: '\u70c8\u7130\u7684\u5361\u74e6\u6731',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'scorpio',
  },
  {
    _id: 'ilynav',
    name: '\u4f0a\u8389\u5a1c\u8299',
    rarity: 5,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'gemini',
  },
  { _id: 'iseria', name: '\u4f0a\u8cfd\u9e97\u4e9e', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  { _id: 'jack-o', name: '\u6f54\u514b\u2027\u6b50', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'taurus ' },
  {
    _id: 'judge-kise',
    name: '\u5be9\u5224\u8005\u7dba\u4e16',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'maiden',
  },
  { _id: 'kawerik', name: '\u5361\u5a01\u5229', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'kayron', name: '\u51f1\u9686', rarity: 5, role: 'assassin', attribute: 'fire', zodiac: 'ram' },
  { _id: 'ken', name: '\u80af\u6069', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'kise', name: '\u7dba\u4e16', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'krau', name: '\u514b\u52de\u70cf', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'fish' },
  { _id: 'landy', name: '\u862d\u8482', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'last-rider-krau',
    name: '\u6700\u5f8c\u7684\u9a0e\u58eb\u514b\u52de\u70cf',
    rarity: 5,
    role: 'knight',
    attribute: 'light',
    zodiac: 'fish',
  },
  { _id: 'lidica', name: '\u9e97\u8fea\u5361', rarity: 5, role: 'ranger', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'lilias', name: '\u8389\u8389\u4e9e\u65af', rarity: 5, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  { _id: 'lilibet', name: '\u8389\u8389\u8c9d', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  {
    _id: 'lionheart-cermia',
    name: '\u7345\u5fc3\u738b\u6f54\u82e5\u7c73\u4e9e',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  {
    _id: 'little-queen-charlotte',
    name: '\u5e74\u8f15\u7684\u5973\u738b\u590f\u7da0\u8482',
    rarity: 5,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'lua', name: '\u8def\u96c5', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'pisces' },
  { _id: 'ludwig', name: '\u9b6f\u7279\u6bd4', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'lion' },
  { _id: 'luluca', name: '\u7490\u7490\u5361', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'luna', name: '\u9732\u5a1c', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  {
    _id: 'maid-chloe',
    name: '\u50d5\u4eba\u514b\u863f\u611b',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'maiden',
  },
  {
    _id: 'martial-artist-ken',
    name: '\u6b66\u9b25\u5bb6\u80af\u6069',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'mediator-kawerik',
    name: '\u5354\u8abf\u8005\u5361\u5a01\u5229',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'goat',
  },
  {
    _id: 'melany',
    name: '\u73ab\u62c9\u59ae',
    rarity: 3,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'libra',
  },
  { _id: 'melissa', name: '\u6885\u9e97\u838e', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'lion' },
  { _id: 'milim', name: '\u871c\u8389\u59c6', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'cancer' },
  { _id: 'mort', name: '\u9b54\u52d2', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'twins' },
  { _id: 'mui', name: '\u7e46\u4f0a', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'operator-sigret',
    name: '\u64cd\u4f5c\u54e1\u8cfd\u73c2\u862d\u7279',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'scales',
  },
  { _id: 'pavel', name: '\u5e15\u8c9d\u723e', rarity: 5, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  { _id: 'peira', name: '\u6c9b\u4f0a\u62c9', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'virgo ' },
  {
    _id: 'pirate-captain-flan',
    name: '\u6d77\u76dc\u8239\u9577\u8299\u862d',
    rarity: 5,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'virgo ',
  },
  { _id: 'politis', name: '\u4f5b\u91cc\u8482\u7d72', rarity: 5, role: 'mage', attribute: 'fire', zodiac: 'twins' },
  { _id: 'ram', name: '\u62c9\u59c6', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'gemini' },
  { _id: 'ran', name: '\u5d50', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'aries' },
  { _id: 'ravi', name: '\u863f\u83f2', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'goat' },
  { _id: 'ray', name: '\u96f7\u4f0a', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'bull' },
  { _id: 'rem', name: '\u857e\u59c6', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'scorpio' },
  {
    _id: 'remnant-violet',
    name: '\u6b98\u5f71\u7684\u83f2\u5967\u96f7\u6258',
    rarity: 5,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'lion',
  },
  { _id: 'rimuru', name: '\u5229\u59c6\u8def ', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'libra' },
  {
    _id: 'riza-hawkeye',
    name: '\u8389\u838e\u2027\u970d\u514b\u611b',
    rarity: 5,
    role: 'ranger',
    attribute: 'ice',
    zodiac: 'capricorn',
  },
  { _id: 'roana', name: '\u7f85\u5b89\u7d0d', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'fish' },
  {
    _id: 'roy-mustang',
    name: '\u7f85\u4f0a\u2027\u99ac\u65af\u5766\u53e4',
    rarity: 5,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'fish',
  },
  {
    _id: 'ruele-of-light',
    name: '\u5149\u4e4b\u745e\u5152',
    rarity: 5,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'fish',
  },
  {
    _id: 'sage-baal-sezan',
    name: '\u8ce2\u8005\u5df4\u723e&\u585e\u5c1a',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'seaside-bellona',
    name: '\u6d77\u908a\u7684\u7dad\u723e\u863f\u5a1c',
    rarity: 5,
    role: 'ranger',
    attribute: 'ice',
    zodiac: 'twins',
  },
  { _id: 'senya', name: '\u8cfd\u5a1c', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'bull' },
  { _id: 'sez', name: '\u8cfd\u8332', rarity: 5, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'sharun', name: '\u838e\u502b', rarity: 5, role: 'manauser', attribute: 'wind', zodiac: 'gemini' },
  { _id: 'shuna', name: '\u6731\u83dc', rarity: 5, role: 'manauser', attribute: 'fire', zodiac: 'gemini' },
  { _id: 'sigret', name: '\u8cfd\u73c2\u862d\u7279', rarity: 5, role: 'warrior', attribute: 'ice', zodiac: 'bull' },
  {
    _id: 'silver-blade-aramintha',
    name: '\u767d\u9280\u5200\u5203\u7684\u96c5\u62c9\u654f\u5854',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'slyvan-sage-vivian',
    name: '\u68ee\u4e4b\u8ce2\u8005\u8587\u8587\u5b89',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'twins',
  },

  { _id: 'sol', name: '\u7d22\u723e', rarity: 5, role: 'warrior', attribute: 'fire', zodiac: 'archer' },
  {
    _id: 'solitaria-of-the-snow',
    name: '\u96ea\u570b\u7684\u8607\u8389\u5854\u59ae\u4e9e',
    rarity: 5,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'specimen-sez',
    name: '\u5be6\u9a57\u9ad4\u8cfd\u8332',
    rarity: 5,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  {
    _id: 'specter-tenebria',
    name: '\u5e7b\u5f71\u7684\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'spirit-eye-celine',
    name: '\u9748\u773c\u7684\u745f\u7433 ',
    rarity: 5,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'straze',
    name: '\u53f2\u745e\u5091\u601d',
    rarity: 5,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'taurus',
  },
  {
    _id: 'summer-break-charlotte',
    name: '\u6691\u5047\u590f\u7da0\u8482',
    rarity: 5,
    role: 'knight',
    attribute: 'ice',
    zodiac: 'gemini',
  },
  {
    _id: 'summertime-iseria',
    name: '\u5357\u570b\u7684\u4f0a\u8cfd\u8389\u4e9e',
    rarity: 5,
    role: 'ranger',
    attribute: 'fire',
    zodiac: 'capricorn',
  },
  {
    _id: 'taeyou',
    name: '\u592a\u609f',
    rarity: 5,
    role: 'warrior',
    attribute: 'ice',
    zodiac: 'virgo',
  },
  {
    _id: 'tamarinne',
    name: '\u5854\u746a\u6797\u723e',
    rarity: 5,
    role: 'manauser',
    attribute: 'fire',
    zodiac: 'archer',
  },
  {
    _id: 'tenebria',
    name: '\u6cf0\u59ae\u5e03\u91cc\u96c5',
    rarity: 5,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'crab',
  },
  {
    _id: 'top-model-luluca',
    name: '\u6700\u5f37\u6a21\u7279\u5152\u7490\u7490\u5361',
    rarity: 5,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'archer',
  },
  { _id: 'tywin', name: '\u6cf0\u6eab', rarity: 5, role: 'knight', attribute: 'ice', zodiac: 'ram' },
  { _id: 'vildred', name: '\u7dad\u5fb7\u745e', rarity: 5, role: 'assassin', attribute: 'wind', zodiac: 'lion' },
  {
    _id: 'violet',
    name: '\u83f2\u5967\u96f7\u6258',
    rarity: 5,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'scorpion',
  },
  { _id: 'vivian', name: '\u8587\u8587\u5b89', rarity: 5, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  { _id: 'yufine', name: '\u512a\u82ac\u59ae', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'bull' },
  { _id: 'yulha', name: '\u5f8b\u8377', rarity: 5, role: 'knight', attribute: 'wind', zodiac: 'sagittarius' },
  { _id: 'yuna', name: '\u5c24\u5a1c', rarity: 5, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  { _id: 'zahhak', name: '\u672d\u54c8\u514b', rarity: 5, role: 'warrior', attribute: 'wind', zodiac: 'sagittarius' },
  { _id: 'zeno', name: '\u5091\u8afe', rarity: 5, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  { _id: 'zio', name: '\u667a\u6b66', rarity: 5, role: 'mage', attribute: 'dark', zodiac: 'bull' },
  { _id: 'achates', name: '\u96c5\u5361\u6cf0\u7d72', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'angel-of-light-angelica',
    name: '\u5149\u4e4b\u5929\u4f7f\u5b89\u6f54\u8389\u5361',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'taurus',
  },
  { _id: 'angelica', name: '\u5b89\u6f54\u8389\u5361', rarity: 4, role: 'manauser', attribute: 'ice', zodiac: 'crab' },
  { _id: 'armin', name: '\u4e9e\u654f', rarity: 4, role: 'knight', attribute: 'wind', zodiac: 'goat' },
  {
    _id: 'assassin-cartuja',
    name: '\u6bba\u624b\u5361\u723e\u5716\u54c8',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'assassin-cidd',
    name: '\u6bba\u624b\u5e2d\u5fb7',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'waterbearer',
  },
  {
    _id: 'assassin-coli',
    name: '\u6bba\u624b\u53ef\u9e97',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'auxiliary-lots',
    name: '\u8f14\u52a9\u578b\u62c9\u8332',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'bad-cat-armin',
    name: '\u58de\u58de\u8c93\u4e9e\u654f',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'aries',
  },
  {
    _id: 'benevolent-romann',
    name: '\u4ec1\u6148\u7684\u6d1b\u66fc',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'bull',
  },
  {
    _id: 'blaze-dingo',
    name: '\u70c8\u706b\u6c40\u679c',
    rarity: 4,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'archer',
  },
  {
    _id: 'blood-blade-karin',
    name: '\u8840\u528d\u5361\u7433',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  { _id: 'cartuja', name: '\u5361\u723e\u5716\u54c8', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'crab' },
  {
    _id: 'celestial-mercedes',
    name: '\u5916\u592a\u7a7a\u7684\u73ab\u52d2\u8cfd\u5fb7\u7d72',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'challenger-dominiel',
    name: '\u6311\u6230\u8005\u591a\u7c73\u59ae\u723e',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'scorpion',
  },
  {
    _id: 'champion-zerato',
    name: '\u7d42\u7d50\u8005\u6770\u62c9\u5716',
    rarity: 4,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'ram',
  },
  { _id: 'cidd', name: '\u5e2d\u5fb7', rarity: 4, role: 'assassin', attribute: 'wind', zodiac: 'ram' },
  { _id: 'clarissa', name: '\u514b\u840a\u8389\u838e', rarity: 4, role: 'warrior', attribute: 'ice', zodiac: 'lion' },
  { _id: 'coli', name: '\u53ef\u9e97', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'corvus', name: '\u79d1\u723e\u5e03\u601d', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'crab' },
  {
    _id: 'crescent-moon-rin',
    name: '\u65b0\u6708\u821e\u59ec\u9234\u5152',
    rarity: 4,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'crimson-armin',
    name: '\u7d05\u7130\u4e9e\u654f',
    rarity: 4,
    role: 'knight',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'crozet', name: '\u514b\u7f85\u6fa4', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'crab' },
  { _id: 'dingo', name: '\u6c40\u679c', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'dominiel', name: '\u591a\u7c73\u59ae\u723e', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'bull' },
  {
    _id: 'fighter-maya',
    name: '\u6230\u9b25\u578b\u746a\u96c5',
    rarity: 4,
    role: 'knight',
    attribute: 'light',
    zodiac: 'scales',
  },
  {
    _id: 'free-spirit-tieria',
    name: '\u6c38\u6046\u4e0d\u8b8a\u7684\u9edb\u8389\u4e9e',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'maiden',
  },
  { _id: 'furious', name: '\u5c24\u8c9d\u70cf\u65af', rarity: 4, role: 'ranger', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'general-purrgis',
    name: '\u5927\u5c07\u6cd5\u6fdf\u65af',
    rarity: 4,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'great-chief-khawana',
    name: '\u5927\u65cf\u9577\u5361\u74e6\u5a1c',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'bull',
  },
  {
    _id: 'guider-aither',
    name: '\u6c42\u9053\u8005\u57c3\u5fb7\u52d2',
    rarity: 4,
    role: 'mage',
    attribute: 'light',
    zodiac: 'crab',
  },
  { _id: 'karin', name: '\u5361\u7433', rarity: 4, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  { _id: 'khawana', name: '\u5361\u74e6\u5a1c', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  { _id: 'khawazu', name: '\u5361\u74e6\u6731', rarity: 4, role: 'warrior', attribute: 'fire', zodiac: 'scorpion' },
  {
    _id: 'kitty-clarissa',
    name: '\u8c93\u54aa\u514b\u840a\u8389\u838e',
    rarity: 4,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'maiden',
  },
  { _id: 'kizuna-ai', name: '\u7d46\u611b', rarity: 4, role: 'manauser', attribute: 'fire', zodiac: 'crab' },
  { _id: 'leo', name: '\u96f7\u6b50', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'lots', name: '\u62c9\u8332', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'twins' },
  { _id: 'maya', name: '\u746a\u96c5', rarity: 4, role: 'knight', attribute: 'fire', zodiac: 'ram' },
  {
    _id: 'mercedes',
    name: '\u73ab\u52d2\u8cfd\u5fb7\u7d72',
    rarity: 4,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'scorpion',
  },
  {
    _id: 'moon-bunny-dominiel',
    name: '\u6708\u5154\u591a\u7c73\u59ae\u723e',
    rarity: 4,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'taurus',
  },
  {
    _id: 'peacemaker-furious',
    name: '\u5e73\u8861\u7684\u5c24\u8c9d\u70cf\u65af',
    rarity: 4,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'scorpio',
  },
  { _id: 'purrgis', name: '\u6cd5\u6fdf\u65af', rarity: 4, role: 'warrior', attribute: 'wind', zodiac: 'scorpion' },
  { _id: 'rin', name: '\u9234\u5152', rarity: 4, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'roaming-warrior-leo',
    name: '\u6d41\u6d6a\u52c7\u58eb\u96f7\u6b50',
    rarity: 4,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  { _id: 'romann', name: '\u6d1b\u66fc', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'twins' },
  { _id: 'rose', name: '\u863f\u5b63', rarity: 4, role: 'knight', attribute: 'ice', zodiac: 'scales' },
  { _id: 'schuri', name: '\u4fee\u91cc', rarity: 4, role: 'ranger', attribute: 'fire', zodiac: 'lion' },
  { _id: 'serila', name: '\u585e\u9e97\u62c9', rarity: 4, role: 'mage', attribute: 'fire', zodiac: 'waterbearer' },
  {
    _id: 'shadow-rose',
    name: '\u6697\u5f71\u863f\u5b63',
    rarity: 4,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'shooting-star-achates',
    name: '\u6d41\u661f\u96c5\u5361\u6cf0\u7d72',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'crab',
  },
  { _id: 'silk', name: '\u5e2d\u53ef', rarity: 4, role: 'ranger', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'sinful-angelica',
    name: '\u7f6a\u623e\u7684\u5b89\u6f54\u8389\u5361',
    rarity: 4,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'bull',
  },
  { _id: 'surin', name: '\u8607\u7433', rarity: 4, role: 'assassin', attribute: 'fire', zodiac: 'twins' },
  {
    _id: 'tempest-surin',
    name: '\u98a8\u96f2\u8607\u7433',
    rarity: 4,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'twins',
  },
  {
    _id: 'troublemaker-crozet',
    name: '\u4e0d\u6cd5\u4e4b\u5f92\u514b\u7f85\u6fa4',
    rarity: 4,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'fish',
  },
  {
    _id: 'wanderer-silk',
    name: '\u6d41\u6d6a\u8005\u5e2d\u53ef',
    rarity: 4,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'goat',
  },
  {
    _id: 'watcher-schuri',
    name: '\u6ce8\u8996\u8005\u4fee\u91cc',
    rarity: 4,
    role: 'ranger',
    attribute: 'light',
    zodiac: 'scorpion',
  },
  { _id: 'zerato', name: '\u6770\u62c9\u5716', rarity: 4, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'adin', name: '\u827e\u5ead', rarity: 3, role: 'assassin', attribute: 'wind', zodiac: 'leo' },
  { _id: 'adlay', name: '\u4e9e\u8fea\u8cf4', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'archer' },
  {
    _id: 'adventurer-ras',
    name: '\u5192\u96aa\u5bb6\u62c9\u65af',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'scales',
  },
  { _id: 'ainos', name: '\u827e\u8afe\u65af', rarity: 3, role: 'manauser', attribute: 'dark', zodiac: 'archer' },
  { _id: 'ains', name: '\u827e\u56e0\u8332', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'scales' },
  { _id: 'aither', name: '\u57c3\u5fb7\u52d2', rarity: 3, role: 'manauser', attribute: 'ice', zodiac: 'scales' },
  { _id: 'alexa', name: '\u96c5\u8389\u838e', rarity: 3, role: 'assassin', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'allrounder-wanda',
    name: '\u7591\u96e3\u96dc\u75c7\u5c08\u5bb6\u6c6a\u9054',
    rarity: 3,
    role: 'ranger',
    attribute: 'dark',
    zodiac: 'twins',
  },
  {
    _id: 'angelic-montmorancy',
    name: '\u5b88\u8b77\u5929\u4f7f\u8499\u8309\u6717\u897f',
    rarity: 3,
    role: 'manauser',
    attribute: 'ice',
    zodiac: 'fish',
  },
  { _id: 'arowell', name: '\u96c5\u6d1b\u8587', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'scales' },
  {
    _id: 'azalea',
    name: '\u4e9e\u6f54\u7406\u4e9e',
    rarity: 3,
    role: 'warrior',
    attribute: 'fire',
    zodiac: 'scorpion',
  },
  { _id: 'bask', name: '\u5df4\u601d\u514b', rarity: 3, role: 'knight', attribute: 'ice', zodiac: 'scorpion' },
  { _id: 'batisse', name: '\u5df4\u6258\u65af', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'bull' },
  {
    _id: 'butcher-corps-inquisitor',
    name: '\u5c60\u6bba\u90e8\u968a\u54e1',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  {
    _id: 'camilla',
    name: '\u5361\u5bc6\u62c9',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'virgo',
  },
  {
    _id: 'captain-rikoris',
    name: '\u5148\u92d2\u968a\u9577\u91cc\u79d1\u9ece\u53f8',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  {
    _id: 'carmainerose',
    name: '\u5361\u9ea5\u863f\u8332',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
  { _id: 'carrot', name: '\u5361\u863f', rarity: 3, role: 'mage', attribute: 'fire', zodiac: 'archer' },
  { _id: 'celeste', name: '\u8cfd\u96f7\u65af\u7279', rarity: 3, role: 'ranger', attribute: 'light', zodiac: 'archer' },
  {
    _id: 'chaos-inquisitor',
    name: '\u6df7\u6c8c\u6559\u5c60\u6bba\u8ffd\u64ca\u8005',
    rarity: 3,
    role: 'knight',
    attribute: 'fire',
    zodiac: 'lion',
  },
  {
    _id: 'chaos-sect-axe',
    name: '\u6df7\u6c8c\u6559\u5de8\u65a7\u5927\u5c07\u8ecd',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'christy',
    name: '\u514b\u91cc\u65af\u5a9e',
    rarity: 3,
    role: 'knight',
    attribute: 'wind',
    zodiac: 'capricorn',
  },
  {
    _id: 'church-of-ilryos-axe',
    name: '\u4f0a\u5229\u6b50\u65af\u6559\u65a7\u5175',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'commander-lorina',
    name: '\u6307\u63ee\u5b98\u863f\u91cc\u5a1c',
    rarity: 3,
    role: 'warrior',
    attribute: 'dark',
    zodiac: 'lion',
  },
  {
    _id: 'doll-maker-pearlhorizon',
    name: '\u88fd\u5076\u5e2b\u6ce2\u863f\u840a\u73cd',
    rarity: 3,
    role: 'mage',
    attribute: 'wind',
    zodiac: 'bull',
  },
  { _id: 'doris', name: '\u6735\u8389\u601d', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'crab' },
  { _id: 'eaton', name: '\u4f0a\u9813', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'crab' },
  { _id: 'elson', name: '\u827e\u723e\u68ee', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  { _id: 'enott', name: '\u827e\u8afe\u7279', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scorpion' },
  {
    _id: 'falconer-kluri',
    name: '\u9df9\u7375\u4eba\u53ef\u9732\u8389',
    rarity: 3,
    role: 'knight',
    attribute: 'wind',
    zodiac: 'ram',
  },
  { _id: 'glenn', name: '\u683c\u502b', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'scales' },
  { _id: 'gloomyrain', name: '\u683c\u9b6f\u7f8e\u862d', rarity: 3, role: 'mage', attribute: 'light', zodiac: 'crab' },
  { _id: 'godmother', name: '\u6559\u6bcd', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'twins' },
  { _id: 'gunther', name: '\u5764\u7279', rarity: 3, role: 'warrior', attribute: 'light', zodiac: 'scales' },
  { _id: 'hasol', name: '\u590f\u7387', rarity: 3, role: 'knight', attribute: 'dark', zodiac: 'scales' },
  { _id: 'hataan', name: '\u54c8\u5766', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'lion' },
  { _id: 'hazel', name: '\u6d77\u8332', rarity: 3, role: 'manauser', attribute: 'fire', zodiac: 'waterbearer' },
  { _id: 'helen', name: '\u6d77\u502b', rarity: 3, role: 'knight', attribute: 'ice', zodiac: 'cancer' },
  { _id: 'helga', name: '\u8d6b\u723e\u5609', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  { _id: 'hurado', name: '\u4fee\u62c9\u675c', rarity: 3, role: 'mage', attribute: 'dark', zodiac: 'fish' },
  {
    _id: 'holy-flame-adin',
    name: '\u8056\u708e\u7684\u827e\u5ead',
    rarity: 3,
    role: 'assassin',
    attribute: 'fire',
    zodiac: 'fish',
  },
  { _id: 'ian', name: '\u4f0a\u5b89', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'maiden' },
  { _id: 'januta', name: '\u624e\u52aa\u5854', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'maiden' },
  { _id: 'jecht', name: '\u5091\u514b\u6258', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'archer' },
  { _id: 'jena', name: '\u6377\u5a1c', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'ram' },
  { _id: 'judith', name: '\u8331\u8fea\u7d72', rarity: 3, role: 'assassin', attribute: 'fire', zodiac: 'fish' },
  { _id: 'juni', name: '\u73e0\u59ae', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'sagittarius' },
  {
    _id: 'kikirat-v2',
    name: '\u5947\u5947\u62c9\u7279V.2',
    rarity: 3,
    role: 'knight',
    attribute: 'light',
    zodiac: 'goat',
  },
  { _id: 'kiris', name: '\u5947\u9e97\u7d72', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'goat' },
  { _id: 'kluri', name: '\u53ef\u9732\u8389', rarity: 3, role: 'knight', attribute: 'wind', zodiac: 'ram' },
  { _id: 'lena', name: '\u96f7\u5a1c', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'scales' },
  { _id: 'lilka', name: '\u8389\u73c8', rarity: 3, role: 'ranger', attribute: 'wind', zodiac: 'gemini' },
  { _id: 'lorina', name: '\u863f\u91cc\u5a1c', rarity: 3, role: 'warrior', attribute: 'dark', zodiac: 'lion' },
  { _id: 'lucy', name: '\u9732\u897f', rarity: 3, role: 'manauser', attribute: 'wind', zodiac: 'maiden' },
  {
    _id: 'magic-scholar-doris',
    name: '\u9b54\u6cd5\u5b78\u8005\u6735\u8389\u601d',
    rarity: 3,
    role: 'manauser',
    attribute: 'light',
    zodiac: 'crab',
  },
  {
    _id: 'mascot-hazel',
    name: '\u5409\u7965\u7269\u6d77\u8332',
    rarity: 3,
    role: 'manauser',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
  {
    _id: 'mercenary-helga',
    name: '\u81ea\u7531\u81ea\u5728\u7684\u50ad\u5175\u8d6b\u723e\u5609',
    rarity: 3,
    role: 'warrior',
    attribute: 'wind',
    zodiac: 'archer',
  },
  { _id: 'mirsa', name: '\u7c73\u52d2\u838e', rarity: 3, role: 'assassin', attribute: 'light', zodiac: 'fish' },
  { _id: 'mistychain', name: '\u7f8e\u7d72\u7df9\u5f69', rarity: 3, role: 'mage', attribute: 'ice', zodiac: 'lion' },
  {
    _id: 'montmorancy',
    name: '\u8499\u8309\u6717\u897f',
    rarity: 3,
    role: 'manauser',
    attribute: 'ice',
    zodiac: 'fish',
  },
  { _id: 'mucacha', name: '\u7a46\u5361\u5bdf', rarity: 3, role: 'warrior', attribute: 'wind', zodiac: 'archer' },
  {
    _id: 'muse-rima',
    name: '\u7e46\u65af\u9ece\u746a',
    rarity: 3,
    role: 'ranger',
    attribute: 'ice',
    zodiac: 'waterbearer',
  },
  { _id: 'nuwi', name: '\u6b66\u851a', rarity: 3, role: 'assassin', attribute: 'ice', zodiac: 'scales' },
  { _id: 'nemunas', name: '\u5c3c\u59c6\u62c9\u65af', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'scales' },
  { _id: 'orte', name: '\u5c3c\u59c6\u62c9\u65af', rarity: 3, role: 'ranger', attribute: 'fire', zodiac: 'scales' },
  { _id: 'otillie', name: '\u5967\u6a02\u7df9', rarity: 3, role: 'assassin', attribute: 'wind', zodiac: 'bull' },
  { _id: 'pearlhorizon', name: '\u6ce2\u863f\u840a\u73cd', rarity: 3, role: 'mage', attribute: 'wind', zodiac: 'bull' },
  {
    _id: 'penelope',
    name: '\u6f58\u5c3c\u7f85\u4f69',
    rarity: 3,
    role: 'assassin',
    attribute: 'dark',
    zodiac: 'scorpio',
  },
  { _id: 'pyllis', name: '\u8cbb\u8389\u7d72', rarity: 3, role: 'knight', attribute: 'dark', zodiac: 'crab' },
  { _id: 'ras', name: '\u62c9\u65af', rarity: 3, role: 'knight', attribute: 'fire', zodiac: 'scales' },
  {
    _id: 'requiemroar',
    name: '\u96f7\u594e\u59c6\u6d1b',
    rarity: 3,
    role: 'manauser',
    attribute: 'dark',
    zodiac: 'archer',
  },
  {
    _id: 'researcher-carrot',
    name: '\u7814\u7a76\u8005\u5361\u863f',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'archer',
  },
  {
    _id: 'righteous-thief-roozid',
    name: '\u7fa9\u8cca\u9b6f\u8332\u5fb7',
    rarity: 3,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'twins',
  },
  {
    _id: 'rikoris',
    name: '\u91cc\u79d1\u9ece\u53f8',
    rarity: 3,
    role: 'warrior',
    attribute: 'light',
    zodiac: 'scales',
  },
  { _id: 'rima', name: '\u9ece\u746a', rarity: 3, role: 'ranger', attribute: 'ice', zodiac: 'waterbearer' },
  { _id: 'roozid', name: '\u9b6f\u8332\u5fb7', rarity: 3, role: 'assassin', attribute: 'wind', zodiac: 'twins' },
  {
    _id: 'savior-adin',
    name: '\u6551\u63f4\u8005\u827e\u5ead',
    rarity: 3,
    role: 'assassin',
    attribute: 'light',
    zodiac: 'leo',
  },
  { _id: 'sonia', name: '\u8607\u5c3c\u5a6d', rarity: 3, role: 'manauser', attribute: 'light', zodiac: 'fish' },
  {
    _id: 'summers-disciple-alexa',
    name: '\u590f\u5929\u7684\u5b78\u751f\u96c5\u8389\u838e',
    rarity: 3,
    role: 'assassin',
    attribute: 'ice',
    zodiac: 'leo',
  },
  {
    _id: 'suthan',
    name: '\u65af\u5766',
    rarity: 3,
    role: 'mage',
    attribute: 'dark',
    zodiac: 'aquarius',
  },
  {
    _id: 'shadow-knight-pyllis',
    name: '\u9ed1\u9a0e\u58eb\u8cbb\u8389\u7d72',
    rarity: 3,
    role: 'knight',
    attribute: 'dark',
    zodiac: 'cancer',
  },
  { _id: 'sven', name: '\u53f2\u8cd3', rarity: 3, role: 'assassin', attribute: 'dark', zodiac: 'scorpion' },
  { _id: 'talaz', name: '\u9054\u62c9\u58eb', rarity: 3, role: 'warrior', attribute: 'ice', zodiac: 'leo' },
  { _id: 'talia', name: '\u8389\u73c8', rarity: 3, role: 'assassin', attribute: 'light', zodiac: 'capricorn' },
  {
    _id: 'taranor-guard',
    name: '\u5854\u62c9\u8afe\u723e\u7981\u885b\u968a\u54e1',
    rarity: 3,
    role: 'warrior',
    attribute: 'ice',
    zodiac: 'scales',
  },
  {
    _id: 'taranor-royal-guard',
    name: '\u5854\u62c9\u8afe\u723e\u738b\u5bae\u58eb\u5175',
    rarity: 3,
    role: 'knight',
    attribute: 'ice',
    zodiac: 'scorpion',
  },
  { _id: 'tieria', name: '\u9edb\u8389\u4e9e', rarity: 3, role: 'warrior', attribute: 'fire', zodiac: 'ram' },
  {
    _id: 'unbound-knight-arowell',
    name: '\u81ea\u7531\u9a0e\u58eb\u96c5\u6d1b\u8587',
    rarity: 3,
    role: 'knight',
    attribute: 'light',
    zodiac: 'libra',
  },
  {
    _id: 'verdant-adin',
    name: '\u65b0\u7da0\u7684\u827e\u5ead',
    rarity: 3,
    role: 'assassin',
    attribute: 'wind',
    zodiac: 'leo',
  },
  {
    _id: 'vigilante-leader-glenn',
    name: '\u81ea\u885b\u968a\u968a\u9577\u683c\u502b',
    rarity: 3,
    role: 'ranger',
    attribute: 'wind',
    zodiac: 'libra',
  },

  { _id: 'wanda', name: '\u6c6a\u9054', rarity: 3, role: 'ranger', attribute: 'dark', zodiac: 'twins' },
  { _id: 'yoonyoung', name: '\u5c39\u51cc', rarity: 3, role: 'knight', attribute: 'light', zodiac: 'twins' },
  {
    _id: 'zealot-carmainerose',
    name: '\u50b3\u9053\u8005\u5361\u9ea5\u863f\u8332',
    rarity: 3,
    role: 'mage',
    attribute: 'fire',
    zodiac: 'waterbearer',
  },
];
